import classNames from "classnames";
import { LoginHeaderLanguageSelect } from "./LoginHeaderLanguageSelect";
import { LoginHeaderThemeToggle } from "./LoginHeaderThemeToggle";
import { LoginHeaderLogo } from "./LoginHeaderLogo";
import { LoginHeaderImage } from "./LoginHeaderImage";

export const LoginHeader = () => {
    return (
        <div className={classNames("relative bg-primary rounded-t-3xl h-[240px]", "sm:h-[120px]")}>
            {/* Image Map */}
            <div className={classNames("absolute w-full h-full top-0 left-0 opacity-20 overflow-hidden", "sm:hidden")}>
                <img
                    src={process.env.PUBLIC_URL + "/imgs/bg-map.svg"}
                    className="absolute right-0 bottom-0 translate-x-1/4 translate-y-1/3"
                    alt="login background image map"
                    title="login background image map"
                    width={389}
                    height={242}
                />
            </div>

            {/* Image Tancis/Tanoga */}
            <LoginHeaderImage />

            <div className={classNames("flex justify-between pt-12 px-12", "sm:pt-4 sm:px-8")}>
                <LoginHeaderLogo />
                <div className="flex gap-1 z-10">
                    <LoginHeaderThemeToggle />
                    <LoginHeaderLanguageSelect />
                </div>
            </div>

            {/* Title */}
            <h2
                className={classNames(
                    "absolute top-1/2 left-1/2 -translate-x-1/2 text-[36px] text-primary-contrast font-semibold",
                    "sm:text-[24px]",
                )}
            >
                Login
            </h2>
        </div>
    );
};
